module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_red_x-42492684e24356a4081134894eabeb9e.png";